<template>
  <l-modal
    :title="t('printers.discovery')"
    :description="t('printers.discovery-description')"
    @close="$emit('close')"
  >
    <div v-if="discovering" class="py-8">
      <l-empty-case :type="PrinterSvg">
        {{ t('printers.discovering') }}
      </l-empty-case>
    </div>
    <div v-else-if="!discovering && printers.length === 0" class="py-8">
      <l-empty-case type="empty">
        {{ t('printers.discovery-empty') }}
      </l-empty-case>
    </div>
    <div v-else class="flex flex-col gap-4">
      <l-card-radio
        v-for="printer of printers"
        :key="printer.type + printer.ip + printer.name"
        name="printer"
        :value="printer"
        @click="selectedPrinter = printer"
      >
        <div class="flex items-center gap-4 text-xs leading-4">
          <div class="min-w-32">{{ printer.type }}</div>
          <div>{{ printer.ip ?? printer.name ?? '-' }}</div>
        </div>
      </l-card-radio>
    </div>
    <template #footer>
      <div class="flex items-center gap-4">
        <l-button class="w-full" type="secondary" @click="runAutoDiscovery" :loading="discovering">
          {{ t('printers.discovery-again') }}
        </l-button>
        <l-button
          class="w-full"
          :disabled="!selectedPrinter"
          @click="$emit('newPrinter', selectedPrinter!)"
        >
          {{ t('ctas.add') }}
        </l-button>
      </div>
    </template>
  </l-modal>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { LButton, LCardRadio, LEmptyCase, LModal } from '@last/core-ui/paprika'

import PrinterSvg from '@/assets/printer.svg?raw'
import { discoverPrinters } from '@/integrations/printer/autoDiscovery'
import type { DiscoveredPrinter } from '@/integrations/printer/types'
import { useConfigStore } from '@/store/config'

const { t } = useI18n()

defineEmits<{
  close: []
  newPrinter: [DiscoveredPrinter]
}>()

const configStore = useConfigStore()
const { config } = storeToRefs(configStore)

const discovering = ref(false)
const printers = ref<
  {
    name?: string
    type: 'EscPos' | 'Usb' | 'UsbAndroid'
    ip?: string
  }[]
>([])
const selectedPrinter = ref<{
  name?: string
  type: 'EscPos' | 'Usb' | 'UsbAndroid'
  ip?: string
}>()

onMounted(() => {
  runAutoDiscovery()
})

function runAutoDiscovery() {
  discovering.value = true
  discoverPrinters(Object.values(config.value.printers))
    .then(res => {
      printers.value = res
    })
    .finally(() => {
      discovering.value = false
    })
}
</script>
